import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CountdownTimer, CountdownTimerDateTime } from '../../../models/countdown-timer';

@Component({
  selector: 'lib-left-sidebar-editor',
  templateUrl: './left-sidebar-editor.component.html',
  styleUrls: ['./left-sidebar-editor.component.scss']
})
export class LeftSidebarEditorComponent implements OnChanges {
  @Input() data: CountdownTimer;

  @Output() handleSubmit = new EventEmitter();
  @Output() handleFormValid = new EventEmitter();

  public bindingDateTime: CountdownTimerDateTime;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && changes.data.currentValue) {
      this.bindingDateTime = { ...changes.data.currentValue.dateTime };
    }
  }

  onDatetimeSubmit($event) {
    this.handleSubmit.emit($event);
  }

  onDatetimeValid($event) {
    this.handleFormValid.emit($event);
  }
}
